<template>
  <v-container fluid
  >
    <v-parallax
    :src="require('@/assets/citybridgenight.jpg')"
    height="600">
      <v-container fill-height>
        <v-layout align-center>
          <v-layout row wrap text-xs-center>
            <v-flex xs12>
              <h1 class="display-2 font-weight-thin white--text">Exicon帮助公司筹集资金。</h1>
              <h2 class="display-5 white--text">以便他们可以实现其战略和财务目标。</h2>
              <v-btn 
              color="success" 
              class="white--text"
              large
              :to="'/cn/about'">阅读更多</v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-parallax>
    <v-layout row wrap
    >
      <v-flex xs12>
        <v-layout row wrap           
        class="ma-5">
          <v-layout row wrap
          text-xs-center
          justify-center>
            <h1 class="display-2 font-weight-thin my-2">我们的服务</h1>
            <h1 class="display-5 font-weight-thin my-2">我们通过识别战略合作伙伴或国际投资者来全面或部分收购公司资产，帮助公司实现目标。</h1>
          </v-layout>
          <v-layout row wrap
          text-xs-center
          justify-center>
            <v-btn
            :to="'/cn/contact'">联系我们</v-btn>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="require('@/assets/handshakecolor.jpg')"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="headline">兼并和收购</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <span><strong>全部或部分收购： </strong> 行业整合，进入新市场和现代化家族企业。</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                    flat
                    class="success--text"
                    :to="'/cn/services'"
                    >阅读更多</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
            <v-flex xs12 sm6>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-img
                    class="white--text"
                    height="200px"
                    :src="require('@/assets/singaporecolor.jpg')"
                  >
                    <v-container fill-height fluid>
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="headline">资本筹集</span>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <v-card-title>
                    <div>
                      <span><strong>步入全球金融市场：</strong> 增长投资，降低成本和现代化运营。</span>
                    </div>
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                    flat
                    class="success--text"
                    :to="'/cn/services'"
                    >阅读更多</v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-footer
      height="auto"
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          accent
          pt-2
          text-xs-center
          black--text
          xs12
        >
          <p class="mx-3">同 <strong>Exicon投资银行</strong> 一起实现您的战略和财务目标</p>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      clients: [
        {
          name: 'Sonda (智利)',
          img: 'sonda',
          sector: '资讯科技'
        },
        {
          name: 'Terpel (哥伦比亚)',
          img: 'terpel',
          sector: '石油和天然气'
        },
        {
          name: 'Falabella (智利)',
          img: 'falabella',
          sector: '零售'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .carousel {
    height: 200px;
    width: 80%;
  }

  .client {
    position: absolute;
    bottom: 10px;
    background-color: rgba(0,0,0,0.5);
    color: white;
    font-size: 1.5em;
    padding: 20px;
  }
</style>






// WEBPACK FOOTER //
// src/components/huanyin.vue